import { render, staticRenderFns } from "./ModalPrioritarias.vue?vue&type=template&id=5945c87d"
import script from "./ModalPrioritarias.vue?vue&type=script&lang=js"
export * from "./ModalPrioritarias.vue?vue&type=script&lang=js"
import style0 from "./ModalPrioritarias.vue?vue&type=style&index=0&id=5945c87d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports